import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth'
import { UnknownError } from '@root/shared'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { reportRequestAction } from './report-requests'

import type { DelugeId } from '@root/entities/user-short'

type ReportUserPayload = {
  readonly delugeId: DelugeId
  readonly reason: string
  readonly additionalInformation?: string
}

export const reatomCreateReportUserForm = () => {
  const executeAction = action(async (ctx, args: ReportUserPayload) => {
    const delugeId = ctx.get(delugeIdAtom)

    if (!delugeId) {
      return Result.fail(UnknownError.fromUnknown('no delugeId'))
    }

    return reportRequestAction(ctx, {
      entity: 'user',
      reason: args.reason,
      additionalInfo: args.additionalInformation,
      target: {
        delugeId: args.delugeId,
      },
      fromDelugeId: delugeId,
    })
  }, 'executeAction')

  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestState = reatomRequest({
    execAction: executeAction,
    onResult(ctx, result) {
      Result.match(result, {
        onFailure: (error) => showErrorSnackbarAction(ctx, error),
        onSuccess: () =>
          showSnackbarAction(ctx, {
            text: i18next.t('common.user_reported_successfully'),
            intent: 'success',
          }),
      })
    },
  })

  return { requestState }
}
